import { CANCEL_SCREEN } from 'config/config';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IRecoveryPaymentStatus } from 'types/IRecoveryPayment';

import { RecoveryPaymentButton } from '../recoveryPaymentButton/RecoveryPaymentButton';
import Spinner from '../spinner/Spinner';

import {
  CancelScreenContainer,
  CancelScreenIcon,
  CancelScreenMessage,
  CancelScreenStatus,
  CancelScreenStatusText,
  CancelScreenWrapper,
} from './CancelScreen.styles';

const { status, statusText, icon, description } = CANCEL_SCREEN;

class CancelScreen extends PureComponent<IRecoveryPaymentStatus, { isLoading: boolean }> {
  innerRef = React.createRef<HTMLDivElement>();

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    };
  }

  handleError = (error: Error) => {
    this.setState(() => {
      throw error;
    });
  };

  setLoading = () => {
    this.setState({ isLoading: true });
  };

  render() {
    const { isLoading } = this.state;
    const { recoveryEnabled, paymentId } = this.props;
    const containerHeight = this.innerRef.current ? this.innerRef.current.offsetHeight : 0;

    return (
      <CancelScreenContainer
        isLoading={isLoading}
        height={containerHeight}
        ref={this.innerRef}
        className="cancel-screen__container"
      >
        {isLoading ? (
          <Spinner isLoading={isLoading} />
        ) : (
          <CancelScreenWrapper>
            <CancelScreenStatus className="cancel-screen__status">
              <FormattedMessage id={status} />
            </CancelScreenStatus>
            <CancelScreenStatusText className="cancel-screen__statusText">
              <FormattedMessage id={statusText} />
            </CancelScreenStatusText>
            <CancelScreenIcon className="cancel-screen__icon">
              <img src={icon} alt="icon" />
            </CancelScreenIcon>
            <CancelScreenMessage className="cancel-screen__message">
              <FormattedMessage id={description} />
            </CancelScreenMessage>
            <RecoveryPaymentButton
              className="cancel-screen__recovery-payment-button"
              paymentId={paymentId}
              isRecoveryEnabled={recoveryEnabled}
              message="recoveryPayment"
              onClick={this.setLoading}
              onError={this.handleError}
            />
          </CancelScreenWrapper>
        )}
      </CancelScreenContainer>
    );
  }
}

export default CancelScreen;
